// extracted by mini-css-extract-plugin
module.exports = {"EmptySearchResults":"EmptySearchResults_EmptySearchResults__HhjD5","header":"EmptySearchResults_header__lycBg","message":"EmptySearchResults_message__6Aexe"};